
export const COLORS = {
  brand: {
    white: '#FFFFFF',
    light: '#F4F4F4', // Carbon Gray 10
    secondary: '#FCFCEB', // New Secondary Brand Color
    medium: '#717C26',
    dark: '#474D22',  // Primary Brand Color
    black: '#161616', // Carbon Gray 100
    gray20: '#E0E0E0',
    gray30: '#C6C6C6',
    gray60: '#6F6F6F',
  },
  status: {
    success: '#198038', // Carbon Green 60
    error: '#DA1E28',   // Carbon Red 60
    info: '#0043CE',    // Carbon Blue 70
    warning: '#F1C21B', // Carbon Yellow 20
  },
  channel: {
    edi: '#474D22',
    ebill: '#474D22',
    email: '#005D5D', // Teal 60 for distinction
    print: '#8A3800', // Orange 60 for distinction
  }
};

export const RADII = {
  standard: 'rounded-[6px]', // 6px - Consistent small radius for containers
  element: 'rounded-[6px]',  // 6px - Consistent small radius for elements
  tiny: 'rounded-[3px]',     // 3px - For very small items
  full: 'rounded-full',
};

export const SHADOWS = {
  sm: 'shadow-none',
  md: 'shadow-none', 
  lg: 'shadow-none',
};

export const TRANSITIONS = 'transition-all duration-300 ease-out';
